import {forwardRef, useContext, useEffect, useRef, useState} from "react";
import axios from "axios";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import {SetPrintDataContext} from "../../Pages/index";

import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {ReactTabulator} from "react-tabulator";
import {Bar} from "react-chartjs-2";
import Loader from "../Loader";
import {toast} from "react-toastify";
import Swal from 'sweetalert2'
import ReactToPrint, {PrintContextConsumer} from 'react-to-print';
import login from "../Login";
import tableCalc from "../../utils/tableCalc";
import TabulatorTableOptions from "../../utils/TabulatorTableOptions";
import _axios from "../../httpService"
import {prefixUrl} from "../../utils/utilsData";
import numeric from "../../utils/NumericFunction";
import exportTabulatorData from "../../utils/exportTabulatorData";
import {addSeparatorToData} from "../AccountingCoding/ViewDocuments/ViewDocumentsFunctions";
import Button from "../UI/Button";


export default function FormKpiView(props) {
  let id = "";
  let title = "";
  const location = useLocation();
  const navigateTo = useNavigate();
  const tabulatorRef = useRef();


  const [dataTable, setDataTable] = useState(null);
  const formDOM = useRef(null);

  const [kpiId, setKpiId] = useState(0);

  useEffect(() => {
    if (location.state) {
      id = location.state.value.id;
      setKpiId(id);
      title = location.state.value.title;
      requestTableData(id);
    }
    // document.title = title;
  }, [location]);

  const requestTableData = (deleteKpiId) => {
    let dateToSend = "";
    if (formDOM.current !== null) {
      let v1, v2 = "";
      let elements = formDOM.current.getElementsByTagName('input');
      for (let element of elements) {
        if (element.name === "startDate") {
          v1 = element.value;
        }
        if (element.name === "endDate") {
          v2 = element.value;
        }
      }
      dateToSend = {"startDate": numeric.p2e(v1), "endDate": numeric.p2e(v2)};
    }

    _axios.get(prefixUrl() + '/atprint/' + '?id=' + deleteKpiId + '&dateFilter=' + JSON.stringify(dateToSend))

      // axios({
      //     method: "GET",
      //     url: `${localStorage.getItem("apiUrl")}/atprint/`,
      //     params: {id: deleteKpiId, dateFilter: dateToSend},
      //     headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
      // })
      .then(({data}) => {


        tableCalc.addSeparator(data.column, data.priceFields)
        data.data = addSeparatorToData(data.data, data.priceFields);
        setDataTable(data);
      });
  }


  const deleteThisKpiPlease = (deleteKpiId) => {


    Swal.fire({
      icon: 'warning',
      title: "آیا از حذف این KPI مطمئنید؟",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'بله',
      cancelButtonText: 'لغو',
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "DELETE",
          url: `${localStorage.getItem("apiUrl")}/atprint/`,
          params: {id: deleteKpiId},
          headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
        }).then(({data}) => {
          if (data.status === true) {
            toast.success(data.message);
            navigateTo(-1);
          }
        })
          .catch((error) => {
            if (error.response) {
              if (error) {
                toast.error(error.response.data.message);
              }
            } else {
              console.log(error)
            }

          });
      }
    })


  }


  function printTabulatorHandler() {
    exportTabulatorData.toPrint(tabulatorRef.current)
  }


  return (dataTable === null ? <>
        <Loader/>
      </>
      :
      <div className={"w-1000"} style={{"width": "100%", "height": "85vh", "overflow": "scroll"}}>
        {dataTable.hasDate &&
          <div className={"my-2 rounded border border-black"}>
            <div className={"my-3"}>
              <form ref={formDOM} className={"col-6 row  gx-2 mx-auto my-0"}>
                <div className="col-12">
                  <div className="form-control">
                    <DatePicker
                      calendar={persian}
                      className="form-control"
                      placeholder="از تاریخ"
                      name={"startDate"}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                    />
                  </div>
                </div>
                <div className="col-12 my-4">
                  <div className="form-control col">
                    <DatePicker
                      calendar={persian}
                      className="form-control"
                      placeholder="تا تاریخ"
                      name={"endDate"}
                      locale={persian_fa}
                      calendarPosition="bottom-right"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <button className={"btnCustom btnSubmit"} type="button"
                          onClick={() => requestTableData(kpiId)}
                  > نمایش
                  </button>
                </div>
              </form>

            </div>
          </div>
        }


        <div className={"my-2   d-flex justify-content-right align-content-between text-center"}>
          <div>
            {/*<ReactToPrint content={() => componentRef.current}>*/}
            {/*    <PrintContextConsumer>*/}
            {/*        {({handlePrint}) => (*/}
            {/*            <button className={"btnCustom btnSubmit mx-1"} onClick={handlePrint}>پرینت*/}
            {/*                جدول </button>*/}
            {/*        )}*/}
            {/*    </PrintContextConsumer>*/}
            {/*</ReactToPrint>*/}
            <button className={"btnCustom btnSubmit mx-1"} onClick={printTabulatorHandler}>
              پرینت
              جدول
            </button>


          </div>
          <div>
            <Button
               onClick={(id) => {
              deleteThisKpiPlease(kpiId)
            }}
               color={'redBtn'}
            >حذف KPI فعلی
            </Button>
          </div>
        </div>


        <div className={"mx-2 position-relative"}>
          <div className={""}>
            <ReactTabulator
              ref={tabulatorRef}
              columns={dataTable.column}
              data={dataTable.data}
              options={TabulatorTableOptions.style1}
            />
          </div>
          {/* Maybe Decide To use Chart */}
          {/*{dataTable.chart.length > 0 && <>*/}
          {/*    <div className={""}>*/}
          {/*        <Bar*/}
          {/*            data={dataTable.chart[0].config.data}*/}
          {/*            options={dataTable.chart[0].config.data}*/}
          {/*            // style={{maxHeight: "40vh"}}*/}
          {/*        />*/}
          {/*    </div>*/}
          {/*</>}*/}
        </div>
      </div>
  );
}
